





































































import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  data: () => ({
    selectionTableHeight: 0,
    showClosed: false,
    newSelectionMessage: '',
    selected: {
      id: null,
      name: null,
      description: null,
      closed: null,
      closedFlag: false
    },
    input: {
      name: '',
      description: '',
      closedFlag: false
    },
    filter: null,
    fields: {
      name: {
        label: 'Název výběru',
        tdClass: 'nameStyle',
        sortable: true
      },
      closedFormated: {
        label: 'uzavreno',
        tdClass: 'closedStyle',
        sortable: true
      }
    }
  }),
  watch: {
    '$store.getters.selectionShowClosed': function () {
      this.showClosed = this.$store.getters.selectionShowClosed
      this.$store.commit('cards', [])
      this.$store.commit('selectionSelect', {})
    }
  },
  methods: {
    rowSelected (item: any) {
      if (item.length === 0) {
        this.$store.commit('selectionSelect', {})
      } else {
        this.selected = item[0]
        if (this.selected === undefined) {
          // ked pri pridani noveho zaznamu a reload zmizne oznacenie riadku nenacitavat
        } else {
          axios
            .get('/api/v1/people', {
              params: {
                selection: this.selected.id
              }
            })
            .then(response => (this.$store.commit('cards', response.data)))
          this.$store.commit('selectionSelect', this.selected)
        }
      }
    },
    getClosedSelections () {
      if (this.$store.getters.selectionShowClosed === false) {
        axios
          .get('/api/v1/selection', {
            params: {
              closed: true
            }
          })
          .then(response => {
            let formatedData: any = []
            response.data.forEach(function (data: any) {
              formatedData.push({
                id: data.id,
                name: data.name,
                description: data.description,
                closedFormated: new Date((data.closed)).toLocaleDateString(),
                closedFlag: data.closedFlag
              })
            })
            this.$store.commit('selectionShowClosed', true)
            this.$store.commit('selection', formatedData)
          })
      } else {
        axios
          .get('/api/v1/selection', {
            params: {
              closed: false
            }
          })
          .then(response => {
            this.$store.commit('selectionShowClosed', false)
            this.$store.commit('selection', response.data)
          })
      }
    },
    newSelectionModal () {
      this.input.name = ''
      this.input.description = ''
      this.newSelectionMessage = ''
      this.input.closedFlag = false
      let newSelectionModal: any = this.$refs.newSelectionModal
      newSelectionModal.show()
    },
    newSelectionSave () {
      if (this.input.name === '') {
        this.newSelectionMessage = 'Jméno výběru musí být vyplněno'
      } else {
        axios
          .post('/api/v1/selection', this.input)
          .then(response => {
            axios
              .get('/api/v1/selection')
              .then(response => (this.$store.commit('selection', response.data)))
            this.$store.commit('selectionSelect', {})
            let newSelectionModal: any = this.$refs.newSelectionModal
            newSelectionModal.hide()
            this.$store.commit('selectionShowClosed', false)
          })
          .catch(response => {
            alert('Error: ' + response.data)
            console.log(response.data)
          })
      }
    },
    getClientsHeight () {
      this.selectionTableHeight = document!.getElementById('selectionTable')!.parentElement!.parentElement!.getBoundingClientRect()!.height!
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getClientsHeight)
      this.getClientsHeight()
    })
    axios
      .get('/api/v1/selection', {
        params: {
          closed: false
        }
      })
      .then(response => (this.$store.commit('selection', response.data)))
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getClientsHeight)
  }
})
